/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import styled from "styled-components";

import { DeleteBlock as DeleteBlockIcon } from "src/components/UI/Icons";

interface Props {
  deleteBlock: () => void;
}

export const DeleteButton = ({ deleteBlock }: Props) => {
  return (
    <DeleteButtonWrapper
      onMouseDown={(e) => e.stopPropagation()}
      onClick={deleteBlock}
      id={"cy-block-delete-button"}
    >
      <DeleteBlockIcon />
    </DeleteButtonWrapper>
  );
};

const DeleteButtonWrapper = styled.div`
  width: 20px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: transparent;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: ${({ theme }) => theme.button.hover};
  }
  &:active {
    background-color: ${({ theme }) => theme.button.active};
  }
  @media print {
    display: none;
  }
`;
